<div
  *ngIf="userService.currentUser$ | async as currentUser"
  class="z-5 m-4 lg:border-round-lg bg-gray-900 py-3 px-6 shadow-2 flex align-items-center justify-content-between relative"
>
  <a
    pRipple
    class="cursor-pointer block lg:hidden text-gray-400"
    pStyleClass="@next"
    enterClass="hidden"
    leaveToClass="hidden"
    [hideOnOutsideClick]="true"
    enterActiveClass="scalein"
    leaveActiveClass="fadeout"
  >
    <i class="pi pi-bars text-4xl"></i>
  </a>
  <div
    class="align-items-center flex-grow-1 justify-content-center hidden lg:flex absolute lg:static w-full bg-gray-900 left-0 top-100 px-6 lg:px-0 shadow-2 lg:shadow-none"
  >
    <section></section>
    <ul
      class="list-none no-underline p-0 m-2 flex lg:align-items-center text-gray-400 select-none flex-column lg:flex-row"
    >
      <div *ngFor="let menuItem of menuItems">
        <li
          *hasRoles="menuItem.rolesWithAccess; for: currentUser"
          class="relative no-underline mt-4 lg:mt-0"
        >
          <a
            pRipple
            class="no-underline p-3 align-items-center text-white m-2 border-round-md hover:text-white hover:bg-gray-800 transition-colors transition-duration-150"
            routerLinkActive="border-orange-500 text-orange-500"
            [routerLink]="menuItem.routerLink"
            [routerLinkActiveOptions]="{ exact: true }"
            
          >
            <i class="pi {{ menuItem.icon }} mr-2"></i>
            <span>{{ menuItem.label }}</span>
          </a>
        </li>
      </div>
    </ul>
    <div
      class="flex justify-content-between lg:block border-top-1 lg:border-top-none border-gray-800 py-3 lg:py-0 mt-3 lg:mt-0"
    ></div>
  </div>
</div>
